import React, { FunctionComponent } from "react";
import Text from "../common/text";
import Card from "../common/card";
import { theme } from "../../themes/global";
import { Error, Wrapper, Label } from "./style";
import Input from "../common/input";
import Button from "../common/button";
import Logo from "../common/logo";
import Password from "../common/password";
import ConsentComponent from "../consent";

interface LoginComponentProps {
  handleChange: any;
  handleSubmit: any;
  handleBlur: any;
  values: {
    id: string;
    password: string;
  };
  errors: {
    id?: string;
    password?: string;
  };
}

const LoginComponent: FunctionComponent<LoginComponentProps> = ({
  handleChange,
  handleSubmit,
  handleBlur,
  values,
  errors,
  ...rest
}) => {
  return (
    <Wrapper>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <ConsentComponent />
        <Logo />
        <Text
          css={() => ({
            color: theme.color.primary,
            fontSize: "24px",
            lineHeight: theme.font.tileLineHight,
            fontWeight: "bold",
            opacity: 1,
          })}
        >
          健康観察表
        </Text>
      </div>
      <Card
        css={() => ({
          backgroundColor: theme.color.white,
          width: "100%",
          padding: "11px 26px 0px",
        })}
      >
        <Text
          css={() => ({
            fontSize: "24px",
            lineHeight: theme.font.tileLineHight,
            fontWeight: "bold",
            opacity: 1,
          })}
        >
          ログイン
        </Text>
        <form
          style={{ display: "flex", flexDirection: "column" }}
          method="post"
          onSubmit={handleSubmit}
        >
          <Label>
            <Text
              css={() => ({
                marginRight: "5px",
              })}
            >
              学籍番号
            </Text>
            {errors.id && (
              <Error
                css={() => ({
                  fontSize: "10px",
                  lineHeight: theme.font.midiumLineHight,
                  color: theme.color.warning,
                })}
              >
                {errors.id}
              </Error>
            )}
          </Label>
          <Input
            type="tel"
            name="id"
            value={values.id}
            className={errors.id && "error-input"}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <Label>
            <Text
              css={() => ({
                marginRight: "5px",
              })}
            >
              パスワード
            </Text>
            {errors.password && (
              <Error
                css={() => ({
                  fontSize: "10px",
                  lineHeight: theme.font.midiumLineHight,
                  color: theme.color.warning,
                })}
              >
                {errors.password}
              </Error>
            )}
          </Label>
          <span
            style={{
              opacity: 0.75,
              fontSize: "12px",
              color: theme.color.dark,
              margin: "8px 0",
            }}
          >
            ※初期パスワードは電話番号
          </span>
          <Password
            name="password"
            value={values.password}
            className={errors.password && "error-input"}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Button
            type="submit"
            css={() => ({
              width: "200px",
              margin: "24px auto",
            })}
          >
            ログイン
          </Button>
        </form>
      </Card>
    </Wrapper>
  );
};

export default LoginComponent;
